import { useEffect } from "react";

import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { applyKnowledgeDataSearchCriteria, clearKnowledgeDataSearchCriteria } from "domains/knowledgeData/actions";
import { getKnowledgeDataSearchCriteria } from "domains/knowledgeData/selectors";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";
import { TopicFilterModal } from "domains/topicSearchFilter/components/TopicFilterModal";
import { getTopicFilters } from "domains/topicSearchFilter/selectors";

export const TopicDataFilterModal = () => {
  const dispatch = useDispatch();
  const searchCriteria = useSelector(getKnowledgeDataSearchCriteria);
  const translate = useTranslate();
  const { selectedTopicId } = useSelector(getModalParams) as ModalParams<"TopicDataFilter">;
  const filters = useSelector(getTopicFilters("data"));

  useEffect(() => {
    dispatch(applyKnowledgeDataSearchCriteria({ topicId: selectedTopicId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <TopicFilterModal
      fields={filters}
      handleApplyFilter={(payload) => () => dispatch(applyKnowledgeDataSearchCriteria(payload))}
      handleClear={() => dispatch(clearKnowledgeDataSearchCriteria())}
      searchCriteria={searchCriteria}
      title={translate("app.data.filter.title")}
    />
  );
};
